module.exports = __webpack_public_path__ + "static/media/executive-landscape.7a7e3658.jpg";